module.exports = "/assets/8ccf59e4830d72f92f81bbb24b2127e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/SX.png
// module id = 763
// module chunks = 0